var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import gql from 'graphql-tag';
import { Switch, Redirect, Route } from 'react-router';
import { NavLink } from 'react-router-dom';
import { Query } from 'react-apollo';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
import AdminContent from './AdminContent';
import Member from './Member';
var GET_CURRENT_USER = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  {\n    currentUser {\n      id\n      role\n    }\n  }\n"], ["\n  {\n    currentUser {\n      id\n      role\n    }\n  }\n"])));
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100vh;\n\n  > .header {\n    width: 100%;\n    height: 80px;\n    line-height: 50px;\n    padding: 15px 20px;\n    background-color: #3A405A;\n    color: #fff;\n\n    > .title {\n      float: left;\n      height: 50px;\n      line-height: 30px;\n      padding: 10px 0;\n\n      > img {\n        height: 30px;\n        vertical-align: middle;\n      }\n\n      > span {\n        margin-left: 10px;\n        height: 50px;\n        font-size: 18px;\n      }\n    }\n\n    > .modes {\n      float: right\n\n      > a {\n        color: inherit;\n        text-decoration: none;\n        display: block;\n        float: left;\n        padding: 0 20px;\n        font-size: 16px;\n        cursor: pointer\n        \n        &:not(:first-child) {\n          margin-left: 20px;\n        }\n      }\n\n      > .selected {\n        background: #fff;\n        color: #000;\n        border-radius: 10px;\n      }\n    }\n  }\n\n  > .content {\n    width: 100%;\n    height: calc(100vh - 80px);\n  }\n"], ["\n  width: 100%;\n  height: 100vh;\n\n  > .header {\n    width: 100%;\n    height: 80px;\n    line-height: 50px;\n    padding: 15px 20px;\n    background-color: #3A405A;\n    color: #fff;\n\n    > .title {\n      float: left;\n      height: 50px;\n      line-height: 30px;\n      padding: 10px 0;\n\n      > img {\n        height: 30px;\n        vertical-align: middle;\n      }\n\n      > span {\n        margin-left: 10px;\n        height: 50px;\n        font-size: 18px;\n      }\n    }\n\n    > .modes {\n      float: right\n\n      > a {\n        color: inherit;\n        text-decoration: none;\n        display: block;\n        float: left;\n        padding: 0 20px;\n        font-size: 16px;\n        cursor: pointer\n        \n        &:not(:first-child) {\n          margin-left: 20px;\n        }\n      }\n\n      > .selected {\n        background: #fff;\n        color: #000;\n        border-radius: 10px;\n      }\n    }\n  }\n\n  > .content {\n    width: 100%;\n    height: calc(100vh - 80px);\n  }\n"])));
var Admin = /** @class */ (function (_super) {
    __extends(Admin, _super);
    function Admin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Admin.prototype.render = function () {
        return (React.createElement(Query, { query: GET_CURRENT_USER, fetchPolicy: "network-only" }, function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            if (loading)
                return React.createElement(Loading, null);
            if (error)
                return React.createElement(Error, { error: error });
            // if (!data.currentUser || data.currentUser.role > ROLE.MANAGER) {
            //   this.props.history.push('/mohyun/login')
            // }
            return (React.createElement(Container, null,
                React.createElement("div", { className: "header" },
                    React.createElement("div", { className: "title" },
                        React.createElement("img", { src: require('./icon.png') }),
                        React.createElement("span", null, "\uAD00\uB9AC\uC790 \uD398\uC774\uC9C0")),
                    React.createElement("div", { className: "modes" },
                        React.createElement(NavLink, { to: "/admin/mohyun", activeClassName: "selected" }, "\uBAA8\uD604\uC528\uC564\uB514"),
                        React.createElement(NavLink, { to: "/admin/bmntech", activeClassName: "selected" }, "\uBE44\uC5E0\uC5D4\uD0DD"),
                        React.createElement(NavLink, { to: "/admin/member", activeClassName: "selected" }, "\uD68C\uC6D0\uAD00\uB9AC"))),
                React.createElement("div", { className: "content" },
                    React.createElement(Switch, null,
                        React.createElement(Redirect, { exact: true, path: "/admin", to: "/admin/mohyun" }),
                        React.createElement(Route, { path: "/admin/mohyun", render: function (props) {
                                return React.createElement(AdminContent, __assign({}, props, { project: 'mohyun' }));
                            } }),
                        React.createElement(Route, { path: "/admin/bmntech", render: function (props) {
                                return React.createElement(AdminContent, __assign({}, props, { project: 'bmntech' }));
                            } }),
                        React.createElement(Route, { path: "/admin/member", component: Member })))));
        }));
    };
    return Admin;
}(React.Component));
export default Admin;
var templateObject_1, templateObject_2;
